<div [innerHTML]="communicationText"></div>
